export default __webpack_public_path__ + "static/media/exparts.274391d1.png";